import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: "dashboardui-4ded9.firebaseapp.com",
    projectId: "dashboardui-4ded9",
    storageBucket: "dashboardui-4ded9.appspot.com",
    messagingSenderId: "745823820840",
    appId: "1:745823820840:web:5a7117cb211e10f2db291d",
    measurementId: "G-7K91FLFSLX"
};

const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);
